module.exports = __webpack_public_path__ + "a3cd6bdeafb5b3c498b00127328c549b.svg";